import { Injectable } from "@angular/core";
import { HttpHeaders } from "@angular/common/http";
import { Questionario } from "../entities/questionari";

@Injectable({
	providedIn: "root",
})
export class StorageService {
	// ######################################
	// FUNCTION: constructor
	constructor() { }

	// ######################################
	// FUNCTION: saveQuest
	saveQuest(quest: Questionario) {
		sessionStorage.setItem("SelectedQuest", JSON.stringify(quest));
	}

	// ######################################
	// FUNCTION: getQuest
	getQuest() {
		let tempQ: string | null = sessionStorage.getItem("SelectedQuest");
		if (tempQ) {
			return JSON.parse(tempQ);
		} else {
			return JSON.parse("{}");
		}
	}

	// ######################################
	// FUNCTION: setActiveQuest
	setActiveQuest(quest: Questionario) {
		localStorage.setItem("AmajorCompiledQuest", JSON.stringify(quest));
	}

	// ######################################
	// FUNCTION: getActiveQuest
	getActiveQuest() {
		let activeQ: string | null = localStorage.getItem("AmajorCompiledQuest");
		if (activeQ) {
			return JSON.parse(activeQ);
		} else {
			return null;
		}
	}


	setUser(data) {
		localStorage.setItem("user", JSON.stringify(data));
	}


	saveToken(token: string) {
		// localStorage per persistenza sessione mobile. JWT scade a 31 giorni.
		localStorage.setItem("token", token);
		sessionStorage.setItem("token", token); // compat legacy readers
	}

	getToken() {
		return localStorage.getItem("token") || sessionStorage.getItem("token") || '';
	}

	/**
	 * API JWT — separate slot from the legacy "token" used by the LinkAccess flow.
	 * Read by AuthInterceptor to attach Bearer on protected endpoints.
	 * Usiamo localStorage per non perdere la sessione al close browser mobile.
	 */
	saveApiToken(token: string) {
		localStorage.setItem("apiToken", token);
		sessionStorage.setItem("apiToken", token); // compat legacy readers
	}

	getApiToken() {
		return localStorage.getItem("apiToken") || sessionStorage.getItem("apiToken") || '';
	}

	/** Header JWT per le richieste HttpClient fatte da componenti di moduli lazy:
	 *  chi importa `HttpClientModule` nel lazy module riceve un HttpClient SENZA
	 *  gli interceptor root (AuthInterceptor) → upload Node rifiutati (requireAuth). */
	authHeaders(): HttpHeaders {
		const token = this.getApiToken();
		return token && token.split(".").length === 3
			? new HttpHeaders({ Authorization: `Bearer ${token}` })
			: new HttpHeaders();
	}

	clearApiToken() {
		localStorage.removeItem("apiToken");
		sessionStorage.removeItem("apiToken");
	}

	/**
	 * FAIL-CLOSED: false SOLO se l'apiToken esiste, è un JWT decodificabile con
	 * claim `exp` numerico nel futuro. Token assente, malformato, senza `exp` o
	 * scaduto → true (sessione non utilizzabile).
	 * Chiamanti: `AuthService.isLoggedIn` / `AuthClienteService.isLoggedIn`
	 * (guard admin/cliente). Il flusso di compilazione anonimo non passa di qui.
	 */
	isApiTokenExpired(): boolean {
		const token = this.getApiToken();
		const parts = token.split('.');
		if (parts.length !== 3) return true;
		try {
			const payload = JSON.parse(this.decodeBase64Url(parts[1]));
			return typeof payload.exp !== 'number' || payload.exp * 1000 < Date.now();
		} catch {
			return true;
		}
	}

	// Helper method to decode Base64 URL safe string
	private decodeBase64Url(base64Url: string): string {
		const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
		return atob(base64); // Decode Base64 string
	}


	// ######################################
	// FUNCTION: getActiveQuest
	getUser() {
		let activeQ: string | null = localStorage.getItem("user");
		if (activeQ) {
			return JSON.parse(activeQ);
		} else {
			return null;
		}
	}

	// ######################################
	// FUNCTION: existActiveQuest
	existActiveQuest() {
		let activeQ: string | null = localStorage.getItem("AmajorCompiledQuest");
		if (activeQ) {
			return true;
		} else {
			return false;
		}
	}

	// ######################################
	// FUNCTION: removeActiveQuest
	removeActiveQuest() {
		localStorage.removeItem("AmajorCompiledQuest");
	}

	cleanStorage() {
		localStorage.clear();
	}
}
